import React from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import { Link } from 'react-router-dom';
import * as ROUTES from '../../lib/routing/frontend';
import Helmet from 'react-helmet';
import HospitalCreateForm from '../../components/forms/Hospital/HospitalCreateForm';

class HospitalCreate extends React.Component {
  render() {
    const { onCreate } = this.props;

    return (
      <div>
        <Helmet>
          <title>Add Hospital</title>
        </Helmet>
        <Row>
          <Col>
            <Card className="mb-4">
              <Card.Header className={'card-header--crud'}>
                <div className="d-flex align-items-center">
                  <span className="crud__meta">
                    <Link to={ROUTES.HOSPITALS.ALL.replace('/:page', '')}>&larr; Back to Hospitals</Link>
                  </span>
                </div>
              </Card.Header>
              <Card.Body>
                <Row>
                  <Col>
                    <h1 className="crud__body-title">Add New Hospital</h1>
                  </Col>
                </Row>
                <hr />
                <Row>
                  <Col sm={12} md={8} lg={6}>
                    <HospitalCreateForm onCreate={onCreate} />
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }
}

export default HospitalCreate;
